import { useFlags } from 'launchdarkly-react-client-sdk';

import { DEFAULT_FEATURE_FLAGS, FeatureFlags, FlagKey } from '@/components/providers/FeatureFlagProvider';
import { useGlobalStore } from '@/store';

export function useFeatureFlag<F extends FlagKey>(flagKey: F): FeatureFlags[F] {
    const flags = useFlags();
    const featureFlagOverrides = useGlobalStore((state) => state.featureFlagOverrides);
    return featureFlagOverrides[flagKey] ?? flags[flagKey] ?? DEFAULT_FEATURE_FLAGS[flagKey];
}

export const useFeatureFlags = (): FeatureFlags => {
    return { ...DEFAULT_FEATURE_FLAGS, ...useFlags(), ...useGlobalStore((state) => state.featureFlagOverrides) };
};
